// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__yjq7F","title":"Images45_title__18Yi2","images":"Images45_images__2Eq1q"};